<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
          <h1>Latest Plate Prints</h1>
      </b-col>
    </b-row>
    
    <!-- Latest prints -->
    <b-row>
      <b-col md="12">
        <b-card header="Latest Prints">
          <div v-if="!hasLatestPrintsData" class="form-container">
              <LoadingSpinner />
          </div>
          <div v-if="hasLatestPrintsData">
            <b-table class="mb-0 table-outline" responsive="sm" hover :items="sites" :fields="tableFields" head-variant="light">
              <div slot="user" slot-scope="item">
                <div>{{item.value.name}}</div>
                <div class="small text-muted">
                  Status: {{item.value.registered}}.  Desktop Version: {{item.value.desktopVersion}}
                </div>
              </div>
              <div slot="usage" slot-scope="item">
                <div class="clearfix">
                  <div class="float-left">
                    <strong>{{item.value.value}}</strong>
                  </div>
                  <div class="float-right">
                    <small class="text-muted">{{item.value.period}}</small>
                  </div>
                </div>
                <b-progress height={} class="progress-xs" v-model="item.value.value" :variant="variant(item.value.value)"></b-progress>
              </div>
              <div slot="activity" slot-scope="item">
                <div class="small text-muted">Last Print</div>
                <strong>{{item.value}}</strong>
              </div>
            </b-table>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <!-- End Latest prints -->
  </div>
</template>

<script>
import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';
import moment from 'moment';

const getHTTPHeaders = () => {
  let userObj = JSON.parse(localStorage.getItem('user'));
  let headerConfig = {
      headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authorization': 'Bearer ' + userObj.token,
      }
  }
  return headerConfig;
}

const getSiteDesktopAppVersion = (($http, siteId) => {
  return new Promise((resolve, reject) => {
    let headersObj = getHTTPHeaders();
    $http.get('reports/stats/siteDesktopAppVersion?site_id=' + siteId, headersObj)
      .then((response) => {
          resolve(response.data.desktopAppVersion);
      })
      .catch ((err) => {
          console.error(err);
          reject(err);
      });
  });
});

const getSitesLatestPrints = (($http, companyId) => {
  return new Promise((resolve, reject) => {
    let headersObj = getHTTPHeaders();
    $http.get(`reports/stats/sitesLatestPrints?company_id=${companyId}&all=1`, headersObj)
      .then((response) => {
          resolve(response.data.latestPrints);
      })
      .catch ((err) => {
          console.error(err);
          reject(err);
      });
  });
});

const getSiteList = (($http, companyId) => {
  return new Promise((resolve, reject) => {
    let headersObj = getHTTPHeaders();
    $http.get('site?company_id=' + companyId, headersObj)
      .then((response) => {
          resolve(response.data.sites);
      })
      .catch ((err) => {
          console.error(err);
          reject(err);
      });
  });
});

export default {

  name: 'latestPrintsReport',
  components: {
    LoadingSpinner: LoadingSpinner,
  },
  data: function () {
    return {
      userObj: {},
      sites: [],
      hasLatestPrintsData: false,
      hasPlatesPrintedThisWeekData: false,
      tableFields: {
        user: {
          label: 'Site'
        },
        usage: {
          label: 'Latest Plate Prints'
        },
        activity: {
          label: 'Activity'
        }
      },
    }
  },
  created() {
    this.getUser()
      .then(() => {
        let companyIdToUse = 0;
        let areaIdToUse = 0;
        let siteIdToUse = 0;

        if (this.$data.userObj.auth != "Super Admin") {
          companyIdToUse = this.$data.userObj.company_id;
          areaIdToUse = this.$data.userObj.branch_id;
          siteIdToUse = this.$data.userObj.site_id;
        }

        getSitesLatestPrints(this.$http, companyIdToUse)
          .then((response) => {
            this.$data.sites = response;
             this.$data.hasPlatesPrintedThisWeekData = true;
          });

        if (this.$data.userObj.auth == "Super Admin" || this.$data.userObj.auth == "Company Users") {
          let siteList = [];
          getSiteList(this.$http, companyIdToUse)
            .then((response) => {
              siteList = response;
              if (this.$data.userObj.auth == "Super Admin") {
                return getSitesLatestPrints(this.$http, 0);
              }
              if (this.$data.userObj.auth == "Company Users") {
                return getSitesLatestPrints(this.$http, companyIdToUse);
              }
            })
            .then((response) => {
              
              this.$data.sites = response.map((item) => {
                if (moment(item.printed_date).isDST()) {
                  item.activity = moment(item.printed_date).add(1, 'h').fromNow();
                }
                else {
                  item.activity = moment(item.printed_date).fromNow();
                }
                
                item.user = {name: item.site.site_name, registered: 'ok', desktopVersion: (item.site.dav ? item.site.dav.desktop_app_version : '--')};
                item.usage = {value: parseInt(item.total), period: 'Today'};

                // get the desktop version for each site
                // getSiteDesktopAppVersion(this.$http, item.site_id)
                //   .then((version) => {
                //     item.user.desktopVersion = version;
                //   })
                
                return item;
              });
              this.$data.hasLatestPrintsData = true;
            });
        }
      })
  },
  methods: {
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    getUser() {
      return new Promise((resolve, reject) => {
        this.$data.userObj = JSON.parse(localStorage.getItem('user'));
        if (this.$data.userObj.authcode === undefined) {
          this.$router.push('/pages/login');
        }
        if (this.$data.userObj.auth == "Company Users") {
          this.$data.isCompanyUser = true;
        }
        else {
          this.$data.isCompanyUser = false;
        }
        if (this.$data.userObj.auth == "Super Admin") {
          this.$data.isSuperAdminUser = true;
        }
        else {
          this.$data.isSuperAdminUser = false;
        }
        if (this.$data.userObj.auth == "Area Users") {
          this.$data.isAreaUser = true;
        }
        else {
          this.$data.isAreaUser = false;
        }
        if (this.$data.userObj.auth == "Site Users") {
          this.$data.isSiteUser = true;
        }
        else {
          this.$data.isSiteUser = false;
        }
        resolve();
        
      });
    },
  }
}
</script>

<style>

</style>
